/**
 * Centralized currency formatting utility for Massatherapy
 *
 * Uses British Pounds (GBP) by default, configurable via environment variables.
 */

const CURRENCY = import.meta.env.VITE_CURRENCY || 'GBP';
const LOCALE = import.meta.env.VITE_LOCALE || 'en-GB';

/**
 * Format an amount in the smallest currency unit (cents/pence) to a currency string
 * @param cents - The amount in cents/pence (e.g., 1500 for 15.00)
 * @returns Formatted currency string (e.g., "£15.00")
 */
export function formatCurrency(cents: number): string {
  return new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: CURRENCY,
  }).format(cents / 100);
}

/**
 * Format an amount in whole currency units to a currency string
 * @param amount - The amount in whole units (e.g., 15.00 for £15.00)
 * @returns Formatted currency string (e.g., "£15.00")
 */
export function formatCurrencyAmount(amount: number): string {
  return new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: CURRENCY,
  }).format(amount);
}
